import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';

export default function ApprovalHierarchyPopUpHandle({ open, handleClose, errorCode, error }) {

    let titleStyle = { padding: '1em' };
    let IconComponent = null;
    let buttonStyle = {
        minWidth: '3em',
        minHeight: '2.5em',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderTopRightRadius: "20px",
        borderTopLeftRadius: "20px",
        borderBottomRightRadius: "20px",
        borderBottomLeftRadius: "20px",
    };

    if (String(errorCode).startsWith('5')) {
        titleStyle = { backgroundColor: '#ED5565', height: '2em', padding: '0.3em', color: 'white' };
        buttonStyle = { ...buttonStyle, backgroundColor: '#ED5565', color: 'white', marginTop: '-1.5em' };
        IconComponent = ErrorIcon;
    } else if (String(errorCode).startsWith('4')) {
        titleStyle = { backgroundColor: '#ffbf00', height: '2em', padding: '0.3em', color: 'white' };
        buttonStyle = { ...buttonStyle, backgroundColor: '#ffbf00', color: 'white', marginTop: '-1.5em' };
        IconComponent = WarningIcon;
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{
                style: {
                    backgroundColor: "white",
                    width: '25%',
                    maxWidth: 'none',
                    height: 'auto',
                    maxHeight: '80vh',
                },
            }}
            BackdropProps={{
                style: {
                    backgroundColor: 'transparent',
                },
            }}
        >
            <DialogTitle style={titleStyle}>
                {IconComponent && <IconComponent style={{ verticalAlign: 'middle', marginRight: '0.5em' }} />}
                {String(errorCode).startsWith('5') ? 'Error' : 'Warning'}
            </DialogTitle>
            <DialogContent style={{ padding: '1em', overflow: 'hidden' }}>
                <DialogContentText style={{ textAlign: "center", whiteSpace: 'pre-wrap', overflow: 'hidden', wordBreak: 'break-word' }}>
                    {error}
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
                <Button onClick={handleClose} style={buttonStyle}>Ok</Button>
            </DialogActions>
        </Dialog>
    );
}

ApprovalHierarchyPopUpHandle.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    errorCode: PropTypes.number.isRequired,
    error: PropTypes.string.isRequired,
};
